<template>
  <div class="alipay-callback">
    <el-card shadow="never" class="card">
      <div v-if="loading" class="state">
        <i class="el-icon-loading"></i>
        <p>正在完成支付宝授权，请稍候…</p>
      </div>
      <div v-else-if="error" class="state error">
        <i class="el-icon-warning-outline"></i>
        <p>{{ error }}</p>
        <el-button type="primary" @click="goWithdraw">返回佣金提现</el-button>
      </div>
      <div v-else class="state success">
        <i class="el-icon-success"></i>
        <p>支付宝授权成功</p>
        <el-button type="primary" @click="goWithdraw">返回佣金提现</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { post } from '@/utils/http'

export default {
  name: 'AlipayCallback',
  data() {
    return {
      loading: true,
      error: ''
    }
  },
  async mounted() {
    const authCode = this.$route.query.auth_code || this.$route.query.authCode
    const state = this.$route.query.state
    if (!authCode || !state) {
      this.loading = false
      this.error = '授权回调参数缺失，请重新发起授权'
      return
    }
    if (!localStorage.getItem('token')) {
      this.loading = false
      this.error = '登录已失效，请重新登录后再授权'
      return
    }
    try {
      await post('/admin/alipay/bind', { authCode, state })
      this.loading = false
    } catch (e) {
      this.loading = false
      this.error = e.message || '绑定失败'
    }
  },
  methods: {
    goWithdraw() {
      this.$router.replace('/agent-commission-withdrawal')
    }
  }
}
</script>

<style scoped>
.alipay-callback {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.card {
  width: 420px;
  text-align: center;
}
.state {
  padding: 32px 16px;
}
.state i {
  font-size: 42px;
  margin-bottom: 12px;
}
.state.success i {
  color: #67c23a;
}
.state.error i {
  color: #f56c6c;
}
.state p {
  margin: 12px 0 20px;
  color: #606266;
}
</style>
